import React from 'react';
import SupplierBadge from './SupplierBadge';

function SupplierListItem({
  name,
  logo_url,
  caption,
  tier,
  country,
  shortcode,
  categories = [],
  moq,
  rating,
  city,
  state,
  year_established,
}) {
  return (
    <div className="supplierCard supplierCard-listItem">
      <a href={`/supplier_profiles/${shortcode}`} target="_blank" rel="noopener noreferrer">
        <img src={logo_url} alt={name} className="supplierCardLogo" />
      </a>

      <div className="supplierCardContent">
        <a
          href={`/supplier_profiles/${shortcode}`}
          className="supplierCardLink"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="supplierCardInfo">
            {tier && (
              <div className="mb-2">
                <SupplierBadge tier={tier} />
              </div>
            )}
            <h3 className="title is-5 mb-1">{name}</h3>
            <p className="subtitle is-6 mb-2">{caption}</p>
            <div className="supplierCardDetails mb-4">
              {rating && (
                <span className="mr-4">
                  <span className="icon reviewStar">
                    <i className="ph-bold ph-star"></i>
                  </span>
                  <span>{rating}</span>
                </span>
              )}
              {moq && (
                <span className="mr-4">
                  <span className="icon">
                    <i className="ph-bold ph-cube"></i>
                  </span>
                  <span>MOQ: {moq}</span>
                </span>
              )}
              {(city || state || country) && (
                <span>
                  <span className="icon">
                    <i className="ph-bold ph-map-pin"></i>
                  </span>
                  <span>{[city, state, country].filter(Boolean).join(', ')}</span>
                </span>
              )}
            </div>
            <div className="tags">
              {categories.slice(0, 3).map((category) => (
                <span key={category} className="tag">
                  {category}
                </span>
              ))}
            </div>
          </div>
        </a>
      </div>

      <a
        href={`/supplier_profiles/${shortcode}`}
        className="button is-rounded contactSupplierButton"
        target="_blank"
        rel="noopener noreferrer"
      >
        Contact Supplier
      </a>
    </div>
  );
}

export default SupplierListItem;
